import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const FaceShapeChange = lazyWithPreload(
  () => import('./FaceShapeChange'),
)
